// The sentence the sign-in page shows under the Google button when the API sent the browser back with
// /login?status=invalid&reason=<why>[&email=<google email>] (a Google sign-in it could not complete).
import { BRAND_NAME } from "../../constants/brand";

// Loose shape and length cap: the email is read from the URL and shown as text, nothing else.
const EMAIL_SHAPE = /^[^\s@/\\<>"']{1,64}@[^\s@/\\<>"']{1,189}$/;

export const failedGoogleSignInNotice = (params: URLSearchParams): string => {
    if (params.get("status") !== "invalid") return "";
    if (params.get("reason") === "no_account") {
        const email = params.get("email") || "";
        const who = EMAIL_SHAPE.test(email) ? email : "that Google email";
        return `No ${BRAND_NAME} account matches ${who}. Sign in with the email on your agent account, or ask your agency admin to add you.`;
    }
    return "That Google account could not be signed in. Sign in with the email on your agent account, or ask your agency admin for help.";
};
